import globalVar from "../utils/globalVar";

class SliderBlog {
  constructor() {
    let swiperInstance = null;

    const initFunc = () => {
      registerEvents();
    };

    const registerEvents = () => {
      initSwiper();
      // window.addEventListener("resize", () => initSwiper());
    };

    const initSwiper = () => {
      if (globalVar.tablet.matches) {
        if (!swiperInstance) {
          swiperInstance = new Swiper(".slider-blog-posts", {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    };

    initFunc();
  }
}

export { SliderBlog };
